import { Box } from '@factorialco/deprecated-design-system'
import { TwoColumnLayout } from '@factorialco/f0-react'
import {
  ProcurementApprovalTimelineEntry,
  PurchaseRequestFragment,
} from 'generated/resources/graphql'

import TimelineItem from 'modules/procurement/components/TimelineItem'
import PurchaseRequestSummarySidebar from 'modules/procurement/pages/PurchaseRequestDetailPage/PurchaseRequestSummarySidebar'

interface Props {
  purchaseRequest: PurchaseRequestFragment
  timelineEntries: ProcurementApprovalTimelineEntry[]
}

const WorkflowApprovalLayout = ({ purchaseRequest, timelineEntries }: Props) => {
  const mainContent = (
    <Box paddingTop="s12">
      <Box gap="s8">
        {timelineEntries.map((entry, index) => (
          <TimelineItem
            key={index}
            entry={entry}
            hasConnectingLine={index !== timelineEntries.length - 1}
          />
        ))}
      </Box>
    </Box>
  )

  const sideContent = <PurchaseRequestSummarySidebar purchaseRequest={purchaseRequest} />

  return <TwoColumnLayout sideContent={sideContent}>{mainContent}</TwoColumnLayout>
}

export default WorkflowApprovalLayout
